export default __webpack_public_path__ + "assets/icon-credit-note-grey.c328470b.webp";